import MinuteValuesToggleService from './minuteValuesToggleService';

export default function MinuteValuesToggle(vcom, $) {
  const allowedCharts = ['Wechselrichter', 'Gak', 'meteo', 'met', 'ppc', 'user'];
  const excludedChartsByKeys = [
    'RPP09', // Inverter energy, see bug-14337
    'BFDMT', // Gak Heatmap
    'Q6ZWP', // Inverter Heatmap
    'I5T4G', // Inverter Availability
    'PPCAI', // PPC Active power
    'OL84K', // Satellite data
    'OGZ1P', // Inverter Simulation
    'PPCPD', // PPC Production
    'HMSII', // Inverter Inputs Heatmap
    'DCNSII', // Inverter Inputs DC Current Normalized
  ];
  let minuteValuesControl;

  function setMinuteValuesToggle(systemId, componentType, isSelected) {
    MinuteValuesToggleService.setMinuteValuesToggle(systemId, componentType, isSelected);
  }

  function bindListeners(scope, options) {
    minuteValuesControl.find('input').on('change', (event) => {
      const updateFunc = options.updateFunc ?? null;
      const displayMinuteValues = Boolean(event.target.value);
      setMinuteValuesToggle(options.chart.systemId, options.chart.chartType, displayMinuteValues);
      scope.chart('triggerChartUpdate', updateFunc, scope, { displayMinuteValues });
    });
  }

  function toggleVisibility(chartType, chartKey) {
    const isVisible = allowedCharts.includes(chartType) && !excludedChartsByKeys.includes(chartKey);
    minuteValuesControl.toggle(isVisible);
  }

  function toggleVisibilityPeriod(period) {
    minuteValuesControl.toggle(period === 'tag');
  }

  function getValue() {
    return minuteValuesControl.find('input:checked').val() === '1';
  }

  function setActive(state) {
    const onButton = minuteValuesControl.find('#chart-minute-values-toggle__buttons--on');
    const offButton = minuteValuesControl.find('#chart-minute-values-toggle__buttons--off');

    if (state) {
      onButton.parent().addClass('active');
      onButton.prop('checked', true);
      offButton.parent().removeClass('active');
      offButton.prop('checked', false);
    } else {
      offButton.parent().addClass('active');
      offButton.prop('checked', true);
      onButton.parent().removeClass('active');
      onButton.prop('checked', false);
    }
  }

  function isActive() {
    return minuteValuesControl.find('.active').length >= 1;
  }
  function switchOffMinuteValues() {
    const offValue = '';
    minuteValuesControl.find('input').each((index, element) => {
      const checked = $(element).val() === offValue;
      $(element).prop('checked', checked)
        .parent()
        .toggleClass('active', checked);
    });
  }

  function toggleDisabledState(period) {
    const isDisabled = period !== 'tag';
    minuteValuesControl.find('button').prop('disabled', isDisabled);
    if (isDisabled === true) {
      switchOffMinuteValues();
    }
  }

  function reset(chartType, chartKey, period) {
    toggleVisibility(chartType, chartKey);
    toggleVisibilityPeriod(period);
    toggleDisabledState(period);
  }

  async function getMinuteValuesToggle(systemId, componentType) {
    const isSelected = await MinuteValuesToggleService
      .getMinuteValuesToggle(systemId, componentType);
    setActive(isSelected.data);
  }

  return {
    init(minuteValuesControlElement, systemId, componentType) {
      minuteValuesControl = minuteValuesControlElement;
      getMinuteValuesToggle(systemId, componentType);
    },
    bindListeners,
    reset,
    toggleDisabledState,
    toggleVisibilityPeriod,
    getValue,
    setActive,
    isActive,
    excludedChartsByKeys,
    getMinuteValuesToggle,
    setMinuteValuesToggle,
  };
}
